module.exports = __webpack_public_path__ + "img/base_patrimoine_fontaine.5bac18c6.svg";